<template>
  <vue-tel-input-vuetify
    :outlined="!inline"
    placeholder=""
    label="Phone Number"
    defaultCountry="US"
    mode="international"
    v-model="number"
    :required="required"
    :disabled="disabled"
    :rules="[
      (v) => required ? !!v || 'Phone Number is required' : true,
      isValidOrPossible,
      ...parsedRules
    ]"
    :autoFormat="false"
    :wrapperClasses="classNames"
    @input="onInput"
  />
</template>

<script lang="ts">
import Vue from 'vue';

type PhoneInputData = {
  valid?: boolean;
  number?: { e164?: string };
};

export default Vue.extend({
  name: 'InternationalPhoneNumberInput',
  props: {
    required: Boolean,
    disabled: Boolean,
    inline: Boolean,
    phone: String,
    rules: Array,
    classNames: String,
  },
  data() {
    return {
      number: this.phone ?? "",
      numberData: <PhoneInputData>{},
      dropdownOptions: {
        showDialCodeInSelection: true
      }
    }
  },
  computed: {
    parsedRules: function () {
      if (!!this.rules && !!this.rules.length) {
        return this.rules;
      } else {
        return [];
      }
    }
  },
  watch: {
    phone(newValue?: string) {
      const nextNumber = newValue ?? "";
      if (nextNumber !== this.number) this.number = nextNumber;
    },
    number(newValue: string) { this.$emit('change', newValue); }
  },
  methods: {
    isValidOrPossible(): true | string {
      if (!this.required && !this.number) return true;

      return (!!this.number
          && !!this.numberData
          && this.numberData.valid)
        || 'Phone Number is not valid';
    },
    onInput(number: string, data: PhoneInputData) {
      this.numberData = data;
      if (data?.valid) this.$emit('changeE164', data.number?.e164 ?? "");
      else if (!number) this.$emit('changeE164', "");
      this.$emit('validate', this.isValidOrPossible() === true);
    }
  }
})
</script>
